module.exports = "/images/80cae0578e05d683273cf29de2fbccf6.svg";